<template>
    <div>
        <Modal v-model="show"
            :title="title"
            :width="600"
            @on-visible-change="onModalShow">
            <Spin size="large"
                fix
                v-if="spinShow"></Spin>
            <div>
                <Form>
                    <Row :gutter="16">
                        <Col span="24">
                        <FormItem required
                            label="收货地址:">
                            <Select v-model="addressModel.addressUuid"
                                filterable>
                                <Option :value="item.memberDeliveryAddressUuid"
                                    v-for="item in addressList"
                                    :key="item.memberDeliveryAddressUuid">{{item.distributionStationName + ' ' + item.province + '-' + item.city + '-' + item.dist +"-" +item.memberDeliveryAddressFull+ ' ' + item.memberDeliveryAddressContacts +" " +item.memberDeliveryAddressPhone}}</Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="footer">
                <Button type="success"
                    @click="onOk()">保存</Button>
            </div>
        </Modal>

    </div>
</template>
<script>
import api from '@/api/api';
import { formatDateTimeString } from '@/libs/utils';
export default {
    name: 'BaseModal',
    data() {
        return {
            show: false,
            title: '选择收货地址',
            spinShow: false,
            addressList: [],
            addressModel: {
                orderUuid: '',
                orderType: '',
                addressUuid: ''
            }
        };
    },
    components: {
    },
    methods: {
        formatDateTimeString,
        showModal(orderUuid, orderType) {
            this.addressModel.orderUuid = orderUuid;
            this.addressModel.orderType = orderType;
            this.show = true;
        },
        onModalShow(e) {
            if (e) {
                this.getAddressList();
            }
        },
        getAddressList() {
            this.spinShow = true;
            api.webGetMemberDeliveryAddressList().then(res => {
                this.spinShow = false;
                if (res.code === 0) {
                    this.addressList = res.data.addresses;
                }
            });
        },
        onOk() {
            this.spinShow = true;
            api.webChangeOrderStation(this.addressModel).then(res => {
                this.spinShow = false;
                if (res.code === 0) {
                    this.show = false;
                    this.$parent.getOrderDetailInfo();
                    this.$Modal.success({
                        title: '保存成功'
                    });
                }
            });
        },
        getAddressInfo() {
            this.spinShow = true;
            api.getAddressInfo({ addressStationDeliveryUuid: this.addressModel.addressStationDeliveryUuid }).then(res => {
                this.spinShow = false;
                if (res.code === 0) {
                    Object.assign(this.addressModel, res.data.addressInfo);
                }
            });
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/view/member/address.vue